import { createContext, useContext } from "react";

const GalaxyContext = createContext({ entityType: "", galaxyId: "apps" });

export const GalaxyProvider = GalaxyContext.Provider;
export const useGalaxy = () => useContext(GalaxyContext);
export default GalaxyContext;
